import { Icon } from "@iconify/react";
import Tooltip from "@mui/material/Tooltip";
import formatWAMessage from "./formatWAMessage";
import ImageComponent from "../Components/ImageComponent";
import VideoComponent from "../Components/VideoComponent";
import documentIconDOC from "../Images/DocumentIconDOC.svg";
import documentIconDefault from "../Images/DocumentIconDefault.svg";
import documentIconPDF from "../Images/DocumentIconPDF.svg";
import documentIconPPT from "../Images/DocumentIconPPT.svg";
import documentIconTXT from "../Images/DocumentIconTXT.svg";
import documentIconXLS from "../Images/DocumentIconXLS.svg";
import imagesIcon from "../Images/ImagesIcon.svg";
import videosIcon from "../Images/VideosIcon.svg";
const apiUrl = process.env.REACT_APP_FILE_SERVER_URL;

const renderMessage = (
  message,
  type,
  url,
  TemplateName,
  setIsModalMediaOpen,
  setSelectedMediaURL,
  locationData,
) => {
  const truncateFileName = (fileName) => {
    const NameRegex = /\....*/;
    const tempName = fileName;
    const result = tempName.match(NameRegex);
    const limit = 18;

    if (tempName.length > limit) {
      // Fix for case file have no extension
      if (result) {
        return tempName.substring(0, limit) + "..." + result[0];
      } else {
        return tempName.substring(0, limit) + "...";
      }
    } else {
      return tempName;
    }
  };

  let fileName,
    icon,
    retval,
    noExtension = false;

  if (type === "document") {
    fileName = url.substring(url.lastIndexOf("/") + 1);

    switch (url.substring(url.lastIndexOf(".") + 1)) {
      case "pdf":
        icon = documentIconPDF;
        break;

      case "txt":
        icon = documentIconTXT;
        break;

      case "xls":
      case "xlsx":
        icon = documentIconXLS;
        break;

      case "ppt":
      case "pptx":
        icon = documentIconPPT;
        break;

      case "doc":
      case "docx":
        icon = documentIconDOC;
        break;

      case "jpeg":
      case "jpg":
      case "png":
      case "webp":
        icon = imagesIcon;
        break;

      case "3gp":
      case "aac":
      case "amr":
      case "mp3":
      case "mp4":
      case "ogg":
        icon = videosIcon;
        break;

      default:
        icon = documentIconDefault;
        noExtension = true;
        break;
    }
  }

  if (type === "location") {
    return (
      <div>
        <iframe
          height="175"
          loading="lazy"
          src={`https://www.google.com/maps/embed/v1/place?q=${locationData?.name ?? `${locationData?.latitude}, ${locationData?.longitude}`}&key=AIzaSyCaWAR4c26PRYTXqycgYSkNR89-nIDPMI0&zoom=15`}
          title="maps"
          width="500"
        />

        {locationData?.name ? (
          locationData?.url ? (
            <a
              href={locationData.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "block" }}
            >
              {locationData.name}
            </a>
          ) : (
            <p>{locationData.name}</p>
          )
        ) : (
          ""
        )}

        {locationData?.address && <p>{locationData.address}</p>}

        {locationData?.url && (
          <p>
            {(() => {
              try {
                return new URL(locationData.url).hostname;
              } catch {
                return locationData.url;
              }
            })()}
          </p>
        )}
      </div>
    ); 
  }

  if (url) {
    return (
      <div>
        {type === "audio" && (
          <div className="image-container">
            <audio controls src={`${apiUrl}${url}`} />
          </div>
        )}

        {type === "document" && (
          <>
            <div className="document-container">
              <img src={icon} alt="" className="document-icon" />
              <p className="filename">{truncateFileName(fileName)}</p>

              {
                // Hide button if file have no extension
                !noExtension && (
                  <a
                    className="save-button"
                    href={`${apiUrl}${url}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Tooltip title="Save" arrow>
                      <Icon
                        color="#727272"
                        height="26"
                        icon="ic:baseline-download"
                      />
                    </Tooltip>
                  </a>
                )
              }
            </div>

            {message ? <span className="caption">{message}</span> : ""}
          </>
        )}

        {type === "image" && (
          <div className="image-container">
            <img
              src={`${apiUrl}${url}`}
              alt=""
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaURL(url);
              }}
              className="image"
            />

            <a
              className="save-button"
              download
              href={`${apiUrl}${url}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Tooltip title="Save" arrow>
                <Icon color="#fff" height="30" icon="ic:baseline-download" />
              </Tooltip>
            </a>

            {message ? <span className="caption">{message}</span> : ""}
          </div>
        )}

        {type === "sticker" && (
          <div className="image-container">
            <img
              src={url.includes("CenterixCXUpload") ? `${apiUrl}${url}` : url}
              alt=""
              className="image sticker"
            />
          </div>
        )}

        {(type === "story_reply" || type === "story_mention") && (
          <div className="image-container">
            <ImageComponent
              className="image story"
              src={url}
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaURL(url);
              }}
            />

            <VideoComponent
              className="image story"
              IGStory
              src={url}
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaURL(url);
              }}
            />

            {type === "story_reply" && message ? (
              <span className="caption">{message}</span>
            ) : (
              ""
            )}
          </div>
        )}

        {type === "video" && (
          <div className="image-container">
            <video
              className="image"
              controls
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaURL(url);
              }}
            >
              <source src={`${apiUrl}${url}`} />
            </video>

            {message ? <span className="caption">{message}</span> : ""}
          </div>
        )}
      </div>
    );
  } else {
    retval =
      type === "template"
        ? `Template name: ${TemplateName} \n\n${message}`
        : formatWAMessage(message);
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: retval }}
      style={{ overflowWrap: "anywhere", whiteSpace: "pre-wrap" }}
    />
  );
};

export default renderMessage;
